import { APIResponseStatusType } from '../models/types';
//Error handler based on JSend complieant responses https://github.com/omniti-labs/jsend
export const apiErrorHandler = (response: any): string => {
  let errorMsg = '';
  if (response.status === APIResponseStatusType.FAIL) {
    if (response.data.message) {
      errorMsg = response.data.message;
    } else if (response.data.errors) {
      errorMsg = JSON.stringify(response.data.errors);
    } else {
      let key = Object.keys(response.data)[0];
      if (key) {
        if (typeof response.data[key] === 'string') {
          errorMsg = key + ': ' + response.data[key];
        } else {
          let subkey = Object.keys(response.data[key])[0];
          errorMsg = key + ': ' + subkey + ': ' + response.data[key][subkey];
        }
      }
    }
  } else if (response.status === APIResponseStatusType.ERROR) {
    console.log('error', response.message);

    if (response.message === APIResponseStatusType.UNAUTHORIZED) {
      return APIResponseStatusType.UNAUTHORIZED;
    }
    errorMsg = response.message;
  }
  if (response.isAxiosError) {
    errorMsg = response.message;
  }
  if (errorMsg === '' && typeof response === 'string') {
    return response;
  }
  return errorMsg;
};
